import {
  ClientInfoResponse,
  Compatibility,
  CompatibilityApi,
  DnValidation,
  DnValidationApi,
  IBaseResponse,
  IContractBody,
  IContractResponse,
  IContractResponseApi,
  IDn,
  IInfoClientAvailableCredit,
  IInfoClientAvailableCreditRequest,
  ILoginToSwitchResponse,
  IResponseAvailableCredit,
  IResponseAvailableCreditApi,
  IResponseDnProfile,
  ISaveClientInfo,
  ISaveClientInfoApi,
  ISaveSignature,
  ISaveSignatureApi,
  ISwitchPaymentOption,
  IswitchPaymentOptionResponse,
  IValidationDnTypeService,
  IZipCode,
  IZipCodeApi,
  NumberCheck,
  NumberCheckData,
  OtpResponse,
  OtpResponseValidation,
} from '../interfaces/validations.interface';

//? Adapter Validacion IMEI
export const CompatibilityAdapter = (
  response: IBaseResponse<CompatibilityApi>,
): Compatibility => ({
  success: response?.success || false,
  supportEsim: response?.data?.compatibleToESIM === true,
  message: response?.message,
  homologated: response?.data?.homologated || false,
});

export const NumberCheckAdapter = (
  response: IBaseResponse<NumberCheckData>,
): NumberCheck => ({
  success: response?.success || false,
  isBait: response?.data?.isBait || false,
  isValidToHiring: response?.data?.isValidToHiring || false,
  uri: response?.data?.uri,
  message: response?.message,
});

//? Adapter Validacion dn y otp
export const ValidationDnAdapter = (data: DnValidation): DnValidationApi => ({
  dn: data?.dn || '',
  lada: '52',
  identifier: 'CONFIG_OTP_GENERAL',
});

export const OtpRequestAdapter = (response: OtpResponse): OtpResponse => ({
  success: response?.success || false,
  data: response?.data,
  information: response?.information,
  message: response?.message,
  otp: response?.otp,
});

export const OtpResponseAdapter = (
  response: IBaseResponse<OtpResponseValidation>,
): OtpResponseValidation => ({
  identifier: response?.data?.identifier || 0,
  auth: {
    key: response?.data?.auth?.key || '',
    url: response?.data?.auth?.url || '',
  },
});

export const validationDnTypeAdapter = (
  response: IValidationDnTypeService,
): IValidationDnTypeService => ({
  success: response?.success || false,
  data: response?.data,
  message: response?.message,
  id: response?.id,
});

//? Adapter Informacion Cliente
export const ClientInfoAdapter = (
  response: ClientInfoResponse,
): ClientInfoResponse => ({
  success: response?.success || false,
  data: {
    address: {
      street: response?.data?.address?.street || '',
      zipCode: response?.data?.address?.zipCode || '',
      settlement: response?.data?.address?.settlement || '',
      town: response?.data?.address?.town || '',
      state: response?.data?.address?.state || '',
    },
    birthDay: response?.data?.birthDay
      ? response.data.birthDay.slice(0, 10)
      : '',
    dateOfExpiry: response?.data?.dateOfExpiry
      ? response.data.dateOfExpiry.slice(0, 10)
      : '',
    documentNumber: response?.data?.documentNumber || '',
    age: response?.data?.age || 0,
    taxIdNumber: response?.data?.taxIdNumber || '',
    personalNumber: response?.data?.personalNumber || '',
    registryCode: response?.data?.registryCode || '',
    voterNumber: response?.data?.voterNumber || '',
    firstName: response?.data?.firstName || '',
    lastName: response?.data?.lastName || '',
    gender: response?.data?.gender || '',
    nationality: response?.data?.nationality || '',
  },
});

export const BodyProfileDnAdapter = (dn: IDn): IDn => ({
  value: dn?.value || '',
});

export const ResponseProfileDnAdapter = (
  resp_dn: IResponseDnProfile,
): IResponseDnProfile => ({
  success: resp_dn?.success || false,
  data: {
    msisdn: resp_dn?.data?.msisdn || '',
    imsi: resp_dn?.data?.imsi || '',
    iccid: resp_dn?.data?.iccid || '',
    status: resp_dn?.data?.status || 0,
  },
  message: resp_dn?.message,
  id: resp_dn?.id,
});

//? Adapter Guardar Info Cliente
export const SaveClientInfoAdapter = (
  info: ISaveClientInfo,
): ISaveClientInfoApi => ({
  uuid: info?.uuid || '',
  name: info?.firstName || '',
  lastname: info?.lastName || '',
  surname: info?.middleName || '',
  email: info?.email || '',
  aditionalPhone: info?.number || null,
  contact: info?.contactPhone || '',
  curp: info?.curp || '',
  rfc: info?.rfc || '',
  direction: {
    cp: info?.postalCode || '',
    country: info?.country || '',
    state: info?.state || '',
    municipality: info?.municipality || '',
    colony: info?.colony || '',
    street: info?.address || '',
    external: info?.numExternal,
    internal: info?.numInternal,
  },
  typeService: info?.typeService || '',
  simType: Number.parseInt(info?.simType || '1', 10),
  memberId: info?.employeeId || null,
  privacyNotice: info?.confirmPrivacy || false,
  acceptLegalTerms: info?.confirmLegal || false,
  receiveNotifications: info?.acceptAdvertising || false,
  imei: info?.imei,
  ine: info?.ine,
  dn: info?.dn,
  iccid: info?.iccId || '',
  imsi: info?.imsi || '',
  lineStatus: info?.status || 0,
  birthdate: info?.birthdate,
  portabilityDN: info?.portabilityDN,
});

//? Adapter Codigo Postal
export const ZipCodeAdapter = (resp: IZipCodeApi): IZipCode => {
  const settlements = resp?.data?.settlements || [];

  return {
    success: resp?.success || false,
    data: {
      country: {
        uuid: resp?.data?.country?.uuid || '',
        name: resp?.data?.country?.name || '',
      },
      state: {
        uuid: resp?.data?.state?.uuid || '',
        name: resp?.data?.state?.name || '',
      },
      settlements: settlements.map((colony) => ({
        municipality: {
          uuid: colony?.municipality?.uuid || '',
          name: colony?.municipality?.name || '',
        },
        city: {
          uuid: colony?.city?.uuid || '',
          name: colony?.city?.name || '',
        },
        name: colony?.settlement || '',
        uuid: colony?.uuid || '',
        zipCode: colony?.zipCode || '',
      })),
    },
    municipality: settlements.map((municipality) => ({
      id: municipality?.settlement || '',
      name: municipality?.settlement || '',
    })),
  };
};

//? Adapter Circulo de Credito
export const BodyCreditAvailableAdapter = (
  infoClient: IInfoClientAvailableCredit,
): IInfoClientAvailableCreditRequest => ({
  name: infoClient?.firstName || '',
  lastname: infoClient?.lastName || '',
  surname: infoClient?.middleName || '',
  birthdate: infoClient?.birthday || '',
  rfc: infoClient?.rfc || '',
  direction: infoClient?.address || '',
  colony: infoClient?.colony || '',
  city: infoClient?.city || '',
  zipCode: infoClient?.postalCode || '',
  municipality: infoClient?.municipality || '',
  state: infoClient?.state || '',
});

export const ResponseAvailableCreditAdapter = (
  resp: IResponseAvailableCreditApi,
): IResponseAvailableCredit => ({
  success: resp?.success || false,
  information: {
    uuid: resp?.information?.uuid || '',
    description: resp?.information?.description || '',
    risk: resp?.information?.risk || 0,
    downpayment: resp?.information?.downpayment || 0,
    bail: resp?.information?.bail || 0,
  },
  listOfOffers: (resp?.listOfOffers || []).map((offers) => ({
    offeringId: offers?.offeringId || '',
    name: offers?.name || '',
    image: offers?.image || '',
    include: offers?.include || '',
    enjoy: offers?.enjoy || '',
    duration: offers?.duration || 0,
    price: offers?.price || 0,
    type: offers?.tipo || 0,
    uuid: offers?.uuid,
  })),
});

//? Adapter Informacion Contrato
export const BodyContractInfoAdapter = (
  info: IContractBody,
): IContractBody => ({
  offeringId: info?.offeringId || '',
  price: info?.price || '',
  bail: info?.bail || 0,
});

export const GetInfoContractAdapter = (
  infoContract: IContractResponseApi,
): IContractResponse => ({
  uuid: infoContract?.uuid || '',
  noContract: infoContract?.noContract || '',
  noClient: infoContract?.noClient || '',
  offering: {
    offeringId: infoContract?.offering?.offeringId || '',
    name: infoContract?.offering?.name || '',
    image: infoContract?.offering?.image || '',
    include: infoContract?.offering?.include || '',
    enjoy: infoContract?.offering?.enjoy || '',
    duration: infoContract?.offering?.duration || 0,
    price: infoContract?.offering?.price || 0,
    type: infoContract?.offering?.tipo || 0,
  },
  dateContract: infoContract?.dateContract || '',
  firstName: infoContract?.name || '',
  lastName: infoContract?.lastName || '',
  middleName: infoContract?.surName || '',
  dn: infoContract?.dn || null,
  contactPhone: infoContract?.contact || '',
  email: infoContract?.email || '',
  address: {
    id: infoContract?.address?.id || 0,
    cp: infoContract?.address?.cp || '',
    municipality: infoContract?.address?.municipality || '',
    street: infoContract?.address?.street || '',
    status: infoContract?.address?.status || 0,
    country: infoContract?.address?.country || '',
    colony: infoContract?.address?.colony || '',
    state: infoContract?.address?.state || '',
  },
  numberINE: infoContract?.ine || '',
  imei: infoContract?.imei || '',
});

//? Adapter Firma de Contrato
export const SaveLegalsSignature = (
  signature: ISaveSignature,
): ISaveSignatureApi => ({
  base64: signature?.imageSign || '',
  ext: signature?.imageExt || '',
  acceptTermsAndConditions: signature?.acceptTerms || false,
  privacyNotice: signature?.confirmPrivacy || false,
  acceptLegalTerms: signature?.confirmLegal || false,
  receiveNotifications: signature?.acceptAdvertising || false,
});

//? Adapter login de Cobro (Switch Payment)
export const LoginToSwitchAdapter = (
  response: ILoginToSwitchResponse,
): ILoginToSwitchResponse => ({
  token: response?.access_token || '',
  access_token: response?.access_token || '',
});

//? Adapter Validación de Cobro (Switch Payment)
export const SwitchPaymentOptionAdapter = (
  response: IswitchPaymentOptionResponse,
): ISwitchPaymentOption => ({
  success: response?.success ?? false,
  name: response?.data?.contract?.name ?? '',
  requiresPayment: response?.data?.contract?.payment ?? true,
  bail: response?.data?.contract?.bail ?? 0,
});
